module.exports = __webpack_public_path__ + "static/media/illustration-meditation-relaxed-person.e93be061.svg";